<template>
  <div class="service-page">
    <!-- 整屏模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <div class="section-inner">
          <!-- 背景图需与半透明框同层，backdrop-filter 才能模糊到 -->
          <img v-if="item.key === 'hero'" src="../assets/images/service/service-1-back.png" class="hero-bg" />

          <!-- 模块一：服务与支持 -->
          <div v-if="item.key === 'hero'" class="hero-layout">
            <h2 class="hero-title">{{ $t('service.title') }}</h2>
            <div class="hero-divider"></div>
            <!-- 半透明卡 -->
            <div class="hero-contact-card">
              <!-- 关注二维码 -->
              <div class="hero-card-row hero-card-row-guanzhu">
                <img class="hero-card-guanzhu" :src="$i18n.locale === 'en' ? require('../assets/images/service/service-1-INTguanzhu.png') : require('../assets/images/service/service-1-guanzhu.png')" alt="关注" />
                <span class="hero-card-tip">{{ $t('service.scanQR') }}{{ $t('service.followUs') }}</span>
              </div>
              <!-- 售后二维码 -->
              <div class="hero-card-row hero-card-row-shouhou">
                <img class="hero-card-shouhou" :src="$i18n.locale === 'en' ? require('../assets/images/service/service-1-INTshouhou.png') : require('../assets/images/service/service-1-shouhou.png')" alt="售后" />
                <span class="hero-card-tip">{{ $t('service.scanQR') }}{{ $t('service.afterSales') }}</span>
              </div>
              <!-- 邮箱与电话 -->
              <div class="hero-card-links">
                <div class="hero-card-link">
                  <img class="hero-link-icon" src="../assets/images/service/srvice-1-email.png" alt="邮箱" />
                  <div class="hero-link-text">
                    <span class="hero-link-value">{{ $t('service.heroEmail') }}</span>
                    <span class="hero-link-label">{{ $t('service.heroEmailLabel') }}</span>
                  </div>
                </div>
                <div class="hero-card-link">
                  <img class="hero-link-icon" :src="$i18n.locale === 'en' ? require('../assets/images/service/service-1-INTphone.png') : require('../assets/images/service/service-1-phone.png')" alt="电话" />
                  <div class="hero-link-text">
                    <span class="hero-link-value">{{ $t('service.heroPhone') }}</span>
                    <span class="hero-link-label">{{ $t('service.heroPhoneLabel') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 模块二：常见问题 -->
          <div v-if="item.key === 'faq'" class="faq-layout">
            <div class="faq-header">
              <h2 class="section-title">{{ $t('service.faqTitle') }}</h2>
              <div class="faq-divider"></div>
            </div>
            <div class="faq-list">
              <div class="faq-item" v-for="(faq, idx) in faqList" :key="idx">
                <div class="faq-question" @click="toggleFaq(idx)">
                  <span :class="{ 'is-open': faq.isOpen }">{{ $t(faq.question) }}</span>
                  <!-- 下拉图标（CSS 绘制） -->
                  <span class="faq-icon" :class="{ 'is-open': faq.isOpen }"></span>
                </div>
                <div class="faq-answer" :class="{ 'is-open': faq.isOpen }" :ref="'faqAnswer' + idx">
                  <div class="faq-answer-inner">
                    <p v-if="faq.answer">{{ $t(faq.answer) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 模块三：产品使用教程 -->
          <div v-if="item.key === 'video'" class="video-layout">
            <div class="video-header">
              <h2 class="section-title">{{ $t('service.tutorialTitle') }}</h2>
              <div class="section-divider"></div>
            </div>
            <!-- 说明书入口（public/pdf 包装页） -->
            <a class="pdf-entry" href="pdf/shuoming.html" target="_blank" rel="noopener">
              <span class="pdf-entry-text">{{ $t('service.pdfEntry') }}</span>
              <span class="pdf-entry-icon">
                <span class="arrow"></span>
                <span class="arrow"></span>
                <span class="arrow"></span>
              </span>
            </a>
            <div class="video-list">
              <!-- 佩戴演示 -->
              <div class="video-card video-card-wear">
                <div class="video-player">
                  <video
                    class="video-content"
                    :src="$i18n.locale === 'en' ? require('../assets/video/INTCGM1.mp4') : require('../assets/video/CGM1.mp4')"
                    controls
                    preload="metadata"
                    style="width: 100%; height: 100%; object-fit: contain; background-color: #000;"
                  >
                    {{ $t('service.videoNotSupport') }}
                  </video>
                </div>
                <div class="video-label">{{ $t('service.video1Label') }}</div>
              </div>
              <!-- APP 连接演示 -->
              <div class="video-card video-card-app">
                <div class="video-player">
                  <video
                    class="video-content"
                    src="../assets/video/CGM2.mp4"
                    controls
                    preload="metadata"
                    style="width: 100%; height: 100%; object-fit: contain; background-color: #000;"
                  >
                    {{ $t('service.videoNotSupport') }}
                  </video>
                </div>
                <div class="video-label">{{ $t('service.video2Label') }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'ServicePage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero' },
        { key: 'faq', className: 'module-faq' },
        { key: 'video', className: 'module-video' }
      ],
      visibleMap: {},
      observer: null,
      // 存 i18n 键，随语言切换渲染
      faqList: [
        { question: 'service.faqQ1', answer: 'service.faqA1', isOpen: false },
        { question: 'service.faqQ2', answer: 'service.faqA2', isOpen: false },
        { question: 'service.faqQ3', answer: 'service.faqA3', isOpen: false },
        { question: 'service.faqQ4', answer: 'service.faqA4', isOpen: false },
        { question: 'service.faqQ5', answer: 'service.faqA5', isOpen: false },
        { question: 'service.faqQ6', answer: 'service.faqA6', isOpen: false },
        { question: 'service.faqQ7', answer: 'service.faqA7', isOpen: false },
        { question: 'service.faqQ8', answer: 'service.faqA8', isOpen: false }
      ]
    }
  },
  mounted() {
    // 切换语言后重算已展开项的行为内高度，避免截断
    this.$watch('$i18n.locale', () => {
      this.faqList.forEach((faq, index) => {
        if (!faq.isOpen) return
        const ref = this.$refs['faqAnswer' + index]
        const el = ref && ref[0]
        if (!el) return
        el.style.transition = 'none'
        el.style.height = el.scrollHeight + 'px'
        void el.offsetHeight
        el.style.transition = ''
      })
    })
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    this.initObserver()
    this.scrollToQueryModule()
    // 无 ?to= 时回到顶部；iOS 的 scrollBehavior 不可靠，需先禁用 snap
    if (!this.$route.query.to) {
      const sections = this.$el.querySelectorAll('.fullscreen-section')
      // 临时禁用所有模块与页脚的 scroll-snap，防止吸附到页脚
      const footer = this.$el.querySelector('.footer')
      sections.forEach(s => { s.style.scrollSnapAlign = 'none' })
      if (footer) footer.style.scrollSnapAlign = 'none'
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0)
          // 等滚动稳定后恢复 snap
          setTimeout(() => {
            sections.forEach(s => { s.style.scrollSnapAlign = 'start' })
            if (footer) footer.style.scrollSnapAlign = ''
          }, 200)
        }, 50)
      })
    }
    // 初始全部收起
    this.$nextTick(() => {
      this.faqList.forEach((faq, index) => {
        if (faq.isOpen) return
        const ref = this.$refs['faqAnswer' + index]
        const el = ref && ref[0]
        if (el) el.style.height = '0px'
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    updateScale() {
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    },
    toggleFaq(index) {
      const isOpen = !this.faqList[index].isOpen
      this.faqList[index].isOpen = isOpen
      this.onFaqToggle(index, isOpen)
    },
    // FAQ 展开/收起：行内全程接管 height，避免连点残留监听器
    onFaqToggle(index, isOpen) {
      this.$nextTick(() => {
        const ref = this.$refs['faqAnswer' + index]
        const el = ref && ref[0]
        if (!el) return
        if (isOpen) {
          el.style.height = el.scrollHeight + 'px'
        } else {
          // 强制回流，确保过渡从当前高度出发
          void el.offsetHeight
          el.style.height = '0px'
        }
      })
    },
    // 按 ?to= 定位模块
    scrollToQueryModule() {
      const anchor = this.$route.query.to
      if (!anchor) return
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.module-' + anchor)
          if (el) {
            el.scrollIntoView({ behavior: 'auto' })
          }
        }, 100)
      })
    }
  }
}
</script>

<style scoped>
/* 页面公共样式 */
.service-page {
  padding-top: 0;
}

/* 整屏模块 */
.fullscreen-section {
  height: 100vh;
  /* 手机端可见高度 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
  background: #FFFFFF;
}

/* 设计稿画布 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入：仅透明度，隐藏态不设过渡以便重播 */
  opacity: 0;
  will-change: opacity;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transition: opacity 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 模块一 */
.module-hero {
  background: #FFFFFF;
}

/* 背景图需与半透明框同层，backdrop-filter 才能生效 */
.module-hero .hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  z-index: 0;
}

.module-hero .hero-layout {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 10;
}

.module-hero .hero-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 72px;
  color: #FFFFFF;
  line-height: 1.2;
  text-align: center;
  transform: translate(0, -50px);
}

.module-hero .hero-divider {
  width: 400px;
  height: 1px;
  background-color: #FFFFFF;
  transform: translate(0, -30px);
}

/* 半透明卡 */
.module-hero .hero-contact-card {
  position: relative;
  width: 1100px;
  height: 400px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 24px;
  backdrop-filter: blur(6px);
  box-sizing: border-box;
  transform: translate(0, 150px);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
}

/* 渐变边框 */
.module-hero .hero-contact-card::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 24px;
  padding: 3px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 19%,
    rgba(255, 255, 255, 1) 34%,
    rgba(255, 255, 255, 0) 57%,
    rgba(255, 255, 255, 1) 100%
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

/* 二维码行 */
.module-hero .hero-card-row {
  position: absolute;
  left: 50px;
  display: flex;
  align-items: center;
  gap: 30px;
}

.module-hero .hero-card-row-guanzhu {
  top: 30px;
}

.module-hero .hero-card-row-shouhou {
  bottom: 30px;
}

/* 二维码图 */
.module-hero .hero-card-guanzhu {
  width: 138px;
  height: auto;
  object-fit: contain;
  border-radius: 18px;
}

/* 售后图 */
.module-hero .hero-card-shouhou {
  width: 138px;
  height: auto;
  object-fit: contain;
  border-radius: 18px;
}

/* 提示文字 */
.module-hero .hero-card-tip {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 28px;
  color: #252525;
  white-space: nowrap;
}

/* 英文版提示文字 */
:lang(en) .module-hero .hero-card-tip {
  font-size: 22px;
}

/* 两个绿色框 */
.module-hero .hero-card-links {
  position: absolute;
  top: 50%;
  right: 80px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 60px;
}

/* 单个绿色框 */
.module-hero .hero-card-link {
  width: 380px;
  padding: 20px;
  background: #00ADBB;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 26px;
  color: #FFFFFF;
  text-align: center;
  line-height: 36px;
}

/* 绿色框内图标 */
.module-hero .hero-link-icon {
  width: 76px;
  height: 76px;
  object-fit: contain;
  flex-shrink: 0;
}

/* 绿色框内文字区，固定宽度保证两框图标对齐 */
.module-hero .hero-link-text {
  width: 270px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.module-hero .hero-link-value {
  font-size: 24px;
  line-height: 36px;
}

.module-hero .hero-link-label {
  font-size: 20px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.85);
}

/* 入场动效：保留各元素布局 translate 基准，位移叠加在其后 */
.reveal-section .hero-title {
  opacity: 0;
  transform: translate(0, -50px) translateY(24px);
}

.reveal-section.is-visible .hero-title {
  opacity: 1;
  transform: translate(0, -50px) translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 半透明框连带内容入场，延迟 0.2s 错开 */
.reveal-section .hero-contact-card {
  opacity: 0;
  transform: translate(0, 150px) translateY(50px);
}

.reveal-section.is-visible .hero-contact-card {
  opacity: 1;
  transform: translate(0, 150px) translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.2s;
}

/* 模块二 */
.module-faq {
  background: #FFFFFF;
}

.module-faq .faq-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 160px;
  padding-bottom: 60px;
}

/* 标题区与列表同宽，左边缘对齐 */
.module-faq .faq-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 1100px;
  box-sizing: border-box;
  padding: 0 10px;
}

/* 大标题 */
.module-faq .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 460;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 10px 0 16px 0;
  text-align: left;
}

/* 标题下方短横线 */
.module-faq .faq-divider {
  width: 220px;
  height: 2px;
  background-color: #000000;
}

/* 列表：占满剩余屏高，内容超出时内部滚动再翻页 */
.module-faq .faq-list {
  display: flex;
  flex-direction: column;
  width: 1100px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.module-faq .faq-list::-webkit-scrollbar {
  width: 6px;
}

.module-faq .faq-list::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-radius: 3px;
}

.module-faq .faq-list::-webkit-scrollbar-track {
  background: transparent;
}

.module-faq .faq-item {
  border-bottom: 1px solid #DDDDDD;
}

/* 末项无分隔线 */
.module-faq .faq-item:last-child {
  border-bottom: none;
}

/* 末项展开时底部留白（留白在内层，随高度动画展开） */
.module-faq .faq-item:last-child .faq-answer .faq-answer-inner {
  padding-bottom: 80px;
}

.module-faq .faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 10px 20px;
  cursor: pointer;
}

/* 问题标题，展开时变青色 */
.module-faq .faq-question span {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 460;
  font-size: 26px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  transition: color 0.1s ease;
}

.module-faq .faq-question span.is-open {
  color: #00ADBB;
}

/* 圆形下拉图标 */
.module-faq .faq-icon {
  width: 42px;
  height: 42px;
  border: 2px solid #252525;
  border-radius: 50%;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 箭头本体 */
.module-faq .faq-icon::after {
  content: '';
  width: 10px;
  height: 10px;
  border-right: 2px solid #252525;
  border-bottom: 2px solid #252525;
  transform: rotate(45deg) translate(-2px, -2px);
  transition: transform 0.4s ease;
}

.module-faq .faq-icon.is-open::after {
  transform: rotate(225deg) translate(-2px, -2px);
}

/* 展开区：高度由 JS 行内控制 */
.module-faq .faq-answer {
  overflow: hidden;
  text-align: left;
  background: transparent;
  transition: height 0.4s ease;
}

/* 文字随高度过渡滚动 */
.module-faq .faq-answer p {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #868686;
  line-height: 32px;
  white-space: pre-line;
  margin: 0;
  padding: 0 10px 26px;
  transform: translateY(0);
  transition: transform 0.4s ease;
}

/* 收起态：文字滚回标题处 */
.module-faq .faq-answer:not(.is-open) p {
  transform: translateY(-100%);
}

/* 模块三 */
.module-video {
  background: #F5F5F5;
}

.module-video .video-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 400px;
}

.module-video .video-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(0, -180px);
}

/* 大标题 */
.module-video .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  text-align: center;
  margin: 0 0 20px 0;
  transform: translate(0, 0);
}

/* 标题下方分割线 */
.module-video .section-divider {
  width: 400px;
  height: 1px;
  background-color: #000000;
  margin: 0 auto 24px;
}

/* 说明书入口 */
.module-video .pdf-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1430px;
  box-sizing: border-box;
  padding: 26px 60px;
  margin-top: -140px;
  background: #FFFFFF;
  border-radius: 20px;
  text-decoration: none;
  cursor: pointer;
}

/* 入口文字 */
.module-video .pdf-entry-text {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 30px;
  color: #252525;
  line-height: 1.2;
}

/* 三箭头，由浅到深 */
.module-video .pdf-entry-icon {
  position: relative;
  width: 54px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0;
}

.module-video .pdf-entry-icon .arrow {
  width: 20px;
  height: 20px;
  border-top: 4px solid;
  border-right: 4px solid;
  transform: rotate(45deg);
  flex-shrink: 0;
}

.module-video .pdf-entry-icon .arrow:nth-child(1) {
  border-color: #80D6DC;
}

.module-video .pdf-entry-icon .arrow:nth-child(2) {
  border-color: #00ADBB;
}

.module-video .pdf-entry-icon .arrow:nth-child(3) {
  border-color: #008A96;
}

.module-video .video-list {
  display: flex;
  justify-content: center;
  gap: 90px;
  margin-top: 80px;
}

.module-video .video-card {
  width: 668px;
  background: #FFFFFF;
  border-radius: 16px;
  overflow: hidden;
}

.module-video .video-player {
  width: 100%;
  height: 320px;
  background: #C0C0C0;
  position: relative;
}

.module-video .video-label {
  padding: 20px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  line-height: 32px;
  text-align: center;
}

/* 英文版隐藏说明书入口 */
:lang(en) .module-video .pdf-entry {
  display: none;
}

/* 英文版隐藏 APP 演示卡片 */
:lang(en) .module-video .video-card-app {
  display: none;
}

/* 英文版佩戴卡片 */
:lang(en) .module-video .video-card-wear {
  width: 800px;
  transform: translate(0, -150px);
}

:lang(en) .module-video .video-card-wear .video-player {
  height: 360px;
}

/* 页脚 */
.service-page >>> .footer {
  scroll-snap-align: end;
}

/* 移动端 */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* 禁止 flex 压缩，避免分割线被压成 0 */
  .service-page .section-inner * {
    flex-shrink: 0;
  }

  /* 模块一 */
  .module-hero .hero-layout {
    justify-content: flex-start;
    padding-top: 16vh;
  }

  .module-hero .hero-title {
    font-size: 8vw;
    transform: none;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-hero .hero-title {
    font-size: 6.93vw;
  }

  .module-hero .hero-divider {
    width: 200px;
    transform: none;
    margin: 0 0 4vh 0;
  }

  .module-hero .hero-contact-card {
    width: 88%;
    height: auto;
    transform: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3vh;
    padding: 3vh 7%;
  }

  .module-hero .hero-card-row {
    position: static;
    left: auto;
    top: auto;
    bottom: auto;
    align-self: flex-start;
    gap: 8vw;
  }

  .module-hero .hero-card-guanzhu,
  .module-hero .hero-card-shouhou {
    width: 12vh;
    border-radius: 1vh;
  }

  .module-hero .hero-card-tip {
    font-size: 3.8vw;
    white-space: normal;
  }

  :lang(en) .module-hero .hero-card-tip {
    font-size: 3.2vw;
  }

  .module-hero .hero-card-links {
    position: static;
    left: auto;
    right: auto;
    top: auto;
    transform: none;
    width: 100%;
    gap: 2vh;
  }

  .module-hero .hero-card-link {
    width: 100%;
    padding: 1.5vh 3%;
    gap: 3vw;
    font-size: 3.73vw;
    line-height: 1.4;
  }

  .module-hero .hero-link-icon {
    width: 7vh;
    height: 7vh;
  }

  .module-hero .hero-link-text {
    /* 恢复收缩，防止长邮箱/号码溢出 */
    flex-shrink: 1;
    min-width: 0;
    width: auto;
    flex: 1;
  }

  .module-hero .hero-link-value {
    font-size: 3.47vw;
    line-height: 1.4;
  }

  .module-hero .hero-link-label {
    font-size: 2.93vw;
    line-height: 1.4;
  }

  /* 移动端动效基准覆盖 */
  .reveal-section .hero-title {
    transform: translateY(24px);
  }

  .reveal-section.is-visible .hero-title {
    transform: translateY(0);
  }

  .reveal-section .hero-contact-card {
    transform: translateY(50px);
  }

  .reveal-section.is-visible .hero-contact-card {
    transform: translateY(0);
  }

  /* 模块二 */
  .module-faq .faq-layout {
    padding-top: 76px;
    padding-bottom: 2vh;
  }

  .module-faq .faq-header {
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
  }

  .module-faq .section-title {
    font-size: 5.87vw;
    line-height: 1.3;
    margin: 0 0 1vh 0;
  }

  :lang(en) .module-faq .section-title {
    font-size: 5.33vw;
  }

  .module-faq .faq-divider {
    width: 200px;
    margin-bottom: 2vh;
  }

  /* 列表内部滚动 */
  .module-faq .faq-list {
    flex-shrink: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
  }

  .module-faq .faq-question {
    padding: 2vh 0;
    gap: 3vw;
  }

  .module-faq .faq-question span {
    /* 恢复收缩并允许换行 */
    flex-shrink: 1;
    min-width: 0;
    font-size: 4vw;
    line-height: 1.4;
    white-space: normal;
  }

  :lang(en) .module-faq .faq-question span {
    font-size: 3.73vw;
  }

  .module-faq .faq-icon {
    width: 6vh;
    height: 6vh;
  }

  .module-faq .faq-icon::after {
    width: 1.5vh;
    height: 1.5vh;
  }

  .module-faq .faq-answer p {
    font-size: 3.47vw;
    line-height: 1.6;
    padding: 0 0 3vh;
  }

  :lang(en) .module-faq .faq-answer p {
    font-size: 3.2vw;
  }

  /* 末项底部留白 */
  .module-faq .faq-item:last-child .faq-answer .faq-answer-inner {
    padding-bottom: 8vh;
  }

  /* 模块三 */
  .module-video .video-layout {
    padding-top: 12vh;
  }

  :lang(en) .module-video .video-layout {
    padding-top: 16vh;
  }

  .module-video .video-header {
    transform: none;
  }

  .module-video .section-title {
    font-size: 5.87vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-video .section-title {
    font-size: 5.33vw;
  }

  .module-video .section-divider {
    width: 200px;
    margin: 0 auto 3vh;
  }

  .module-video .pdf-entry {
    width: 88%;
    padding: 2vh 5%;
    margin-top: 0;
    border-radius: 12px;
  }

  .module-video .pdf-entry-text {
    font-size: 4vw;
  }

  .module-video .pdf-entry-icon {
    width: 7.5vh;
    height: 5vh;
    gap: 0;
  }

  .module-video .pdf-entry-icon .arrow {
    width: 2.3vh;
    height: 2.3vh;
  }

  /* 视频卡竖向堆叠 */
  .module-video .video-list {
    flex-direction: column;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
    gap: 3vh;
    margin-top: 3vh;
  }

  .module-video .video-card {
    width: 100%;
  }

  .module-video .video-player {
    height: 24vh;
  }

  .module-video .video-label {
    padding: 2vh;
    font-size: 3.73vw;
    line-height: 1.4;
  }

  /* 英文版佩戴卡片重置 */
  :lang(en) .module-video .video-card-wear {
    width: 100%;
    transform: none;
  }

  :lang(en) .module-video .video-card-wear .video-player {
    height: 45vh;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
